// контекст СЕЛЕКТОРА: [attr="<тут>"] и :contains("<тут>") — ломают только " и \
export const escapeAttrValue = (v) => String(v).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

// контекст HTML-ТЕКСТА: вставка данных в разметку — экранируем & < > " '
export const htmlEscape = (v) => String(v)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
